export default __webpack_public_path__ + "static/media/main-menu.414aec4c.png";